import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './SeDropdownNothingFoundItem.scss';

const SeDropdownNothingFoundItem = () => (
    <FormattedMessage id="tradeUps_nothingFound">
        {txt => <li className={styles.nothingFoundItem}>{txt}</li>}
    </FormattedMessage>
);

export default SeDropdownNothingFoundItem;
